import * as React from "react";

export const fields = (t) => ({
    config: {columns: 1},
    fields: [
        {
            name: "productName",
            label: t ? t("forms.product_name") : "Nazwa produktu",
            column: 1,
            mandatory: true
        },
        {
            name: "seriesNumber",
            label: t ? t("forms.series_number") : "Numer serii",
            column: 1,
            mandatory: true

        },
        {
            name: "orderNumber",
            label: t ? t("forms.order_number") : "Numer zlecenia",
            column: 1,
            mandatory: true

        },
        {
            name: "gmidNumber",
            label: t ? t("forms.gmid") : "GMID",
            column: 1,
            mandatory: true

        },
        {
            name: "productionStartComment",
            label: t ? t("forms.comments") : "Uwagi",
            type: "textarea",
            column: 1,
        },
    ]
});
